/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import { getGradeAndCourse, updateGradeAndCourse } from 'app/course/courseSlice';
import CheckboxInput from 'components/input/CheckboxInput';
import CourseConfig, { hasReOrderGradecourse, resetIndexGradecourse, applyCardExpand, filledExpandArr } from '../CourseConfig';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import CourseWork from '../generalInfo/components/CourseWork';
import { checkEnableParseJSON, isEmptyArrayObject, setArrayLength, tryParseJSON } from 'components/helper/helper';
import { debounce } from 'lodash';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { reorder } from 'components/helper/helper';
import { getHighSchoolData } from 'app/highSchoolSlice/highSchoolSlice';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { chkSameGrade, countSameGrade, getSchoolGradeItems } from '../SubjectConfig';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import { scrollToObject } from 'components/helper/ui_helper';
import YesNoSwitch from 'components/input/YesNoSwitch';
import Grid from '@mui/joy/Grid';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import { ModalCheckGradeField } from 'screen/common/ModalCheckGradeField';
import SearchIcon from '@mui/icons-material/Search';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

interface Props {}

const TwelvethGrade = (props: Props) => {
  const MAX_COURSES = 15;
  const MAX_SUBJECTS = 15;
  const [courseWorkData, setCourseWorkData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [showWarning, setShowWarning] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [errorArr, setErrorArr] = React.useState<any[]>([]);
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const [expandAllCourseWork, setExpandAllCourseWork] = React.useState(false);
  const [expandActiveCourseWork, setExpandActiveCourseWork] = React.useState<number>(0);
  const [expandedArr, setExpandedArr] = React.useState<boolean[]>([]);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const gradeLevel = '12th';
  const course = useAppSelector((store:any) => store.course);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const [courseData, setCourseData] = React.useState<any[]>([]);
  // Keep latest arrays for formik onSubmit — avoids stale wipe on autosave
  const courseDataRef = React.useRef<any[]>(courseData);
  const courseWorkDataRef = React.useRef<any[]>(courseWorkData);
  React.useEffect(() => {
    courseDataRef.current = courseData;
  }, [courseData]);
  React.useEffect(() => {
    courseWorkDataRef.current = courseWorkData;
  }, [courseWorkData]);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');

  const formik = useFormik({
    initialValues: {
      grade_12_course_array: '',
      is_reported_all_grade_12: false,
      number_of_course_to_report: 0,
      course_scheduling_system_is_using: '',
      is_fields_enter_your_current_year_course: false,
      course_title: {
        is_indicated_all_course: false,
        have12thGradeCourses: false,
      },
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          let gradeCourses: any[] = [...courseDataRef.current];
          let bReorder = hasReOrderGradecourse(gradeCourses);

          let newValues = {
            ...values,
            update_grade_no: '12', // update grade 12th only
            student_id: studentId,
            grade_12_course_array: JSON.stringify(gradeCourses),
            course_array: JSON.stringify(courseWorkDataRef.current),
            course_title: JSON.stringify(values.course_title),
            have12thGradeCourses: values.course_title.have12thGradeCourses,
          };
          await dispatch(updateGradeAndCourse(newValues)).unwrap();

          if (bReorder) {
            // update again after reorder item
            resetIndexGradecourse(gradeCourses);
            newValues = {
              ...values,
              update_grade_no: '12', // update grade 12th only
              student_id: studentId,
              grade_12_course_array: JSON.stringify(gradeCourses),
              course_array: JSON.stringify(courseWorkDataRef.current),
              course_title: JSON.stringify(values.course_title),
              have12thGradeCourses: values.course_title.have12thGradeCourses,
            };
            await dispatch(updateGradeAndCourse(newValues)).unwrap();
          }

          await recheckInputSchool();
        } catch (ex) {
          console.log('Error: ', ex);
        }
      } else {
        handleLogout();
      }
    },
  });
  const handleLogout = () => {
    dispatch(logout());
      removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.collegeCourse.path);
  };

  React.useEffect(() => {
    setCourseWorkData(
      setArrayLength(courseWorkData || [], formik.values.number_of_course_to_report)
    );
    setExpandedArr(Array(courseData.length).fill(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.number_of_course_to_report]);

  React.useEffect(() => {
    setExpandedArr((prev) => {
      if (courseData.length === prev.length) return prev;
      if (courseData.length > prev.length) {
        return [...prev, ...Array(courseData.length - prev.length).fill(expandAll)];
      } else {
        return prev.slice(0, courseData.length);
      }
    });
  }, [courseData.length]);

  React.useEffect(() => {
    setExpandedArr((prev) => filledExpandArr(courseData.length, expandAll, prev));
  }, [expandAll, courseData.length]);

  const checkInputSchool = async(gradeCourses:any[], gradeLevel: string) => {
    const gradeMaxCount = 4;
    let arr: any[] = [];
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      const resHighSchool = await dispatch(getHighSchoolData(studentId)).unwrap();
      
      if (resHighSchool) {
        let highschoolData: any[] = resHighSchool.highschoolData;
        if (isEmptyArrayObject(highschoolData)) {
          arr.push({
            value: 'AddHighSchool',
            name: 'Please add high school on the High School page.',
          });
        }
        let itemArr: any[] | null = getSchoolGradeItems(highschoolData, gradeLevel);
        if (itemArr === null) {
          arr.push({
            value: 'AddHighSchool',
            name: 'Please add high school on the High School page.',
          });
        } else {
          if (itemArr && itemArr.length > 1) {
            for (let j = 0; j < itemArr.length; j++) {
              let item: any = itemArr[j].item;
              let item_idx: number = itemArr[j].index;
              if (item) {
                let countArr = countSameGrade(item, gradeLevel);

                if (countArr && countArr.length > 1) {
                  let gradeObj = countArr[countArr.length - 1];
                  arr.push({
                    value: `remove_term${item_idx}_${gradeObj?.index}`,
                    name: `Please remove asleast one term/year has same ${gradeLevel} grade on the High School page.`,
                  });
                }
              }
            }
          }
          //else
          if (highschoolData && highschoolData.length > 0) {
            let obj: any = null;
            for(let m=0; m < gradeCourses.length; m++) {
                let gradeCourse:any = gradeCourses[m];
                let schoolName = gradeCourse.schoolName ?? '';
                let schoolCode =  gradeCourse.schoolCode ?? '';
                for(let i=0; i<highschoolData.length;i++) {
                  let item: any = highschoolData[i];
                  //console.log('item:', item);
                  if (!item.high_school_name) {
                    arr.push({
                      value: `cardItem${i}`,
                      name: 'Please search and select high school on the High School page.',
                    });
                  }
                  if (item.high_school_name === schoolName &&
                      item.high_school_object.college_board_code === schoolCode) {
                        obj = chkSameGrade(item, gradeLevel);
                        if (obj) {
                          let gradeIdx: number = obj.index;
                          if (!item.high_school_object) {
                            arr.push({
                              value: `cardItem${i}`,
                              name: 'Please input high school information on the High School page.',
                            });
                          } else if (item.high_school_object && item.high_school_object.school_name === '') {
                            arr.push({
                              value: `cardItem${i}`,
                              name: 'Please input high school information on the High School page.',
                            });
                          } else if (!item.start_date) {
                            arr.push({
                              value: `start_date${i}`,
                              name: 'Please enter the Start date on the High School page.',
                            });
                          } else if (!item.end_date) {
                            arr.push({
                              value: `end_date${i}`,
                              name: 'Please input the End date on the High School page.',
                            });
                          }
                          if (
                            !item.academic_year[gradeIdx] ||
                            item.academic_year[gradeIdx] === '' ||
                            item.academic_year[gradeIdx] === '- Select -'
                          ) {
                            arr.push({
                              value: `academic_year${i}_${gradeIdx}`,
                              name: 'Please enter the Academic Year on the High School page.',
                            });
                          }
                          if (arr.length > 0) {
                            break;
                          }
                        } 
                        else {
                          if (item.grade && item.grade.length > 0) {
                            if (item.grade.length === gradeMaxCount) {
                              arr.push({
                                value: `grade${i}_${item.grade.length - 1}`,
                                name: `Please select the Grade ${gradeLevel} on the High School page.`,
                              });
                            } else {
                              arr.push({
                                value: `AddTermYear${i}`,
                                name: `Please add another term/year and then select the ${gradeLevel} Grade on the High School page.`,
                              });
                            }
                          } else {
                            arr.push({
                              value: `AddTermYear${i}`,
                              name: `Please add another term/year and then select the ${gradeLevel} Grade on the High School page.`,
                            });
                          }
                        }
                  }
                }
            }

          } else {
            arr.push({
              value: 'AddHighSchool',
              name: 'Please add high school on the High School page.',
            });
          }
        }

        if (arr.length > 0) {
          setShowWarning(true);
          setErrorArr(arr);
        }
        else {
          setShowWarning(false);
        }
      }
      else {
        arr.push({
          value: 'AddHighSchool',
          name: 'Please add high school on the High School page.',
        });
      }
    } else {
      handleLogout();
    }
  };
  const recheckInputSchool = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      const res: any = await dispatch(getGradeAndCourse(studentId));
      let gradeCourses: any[] = tryParseJSON(res.payload.grade_12_course_array) || [];
      await checkInputSchool(gradeCourses, gradeLevel);
    } else {
      handleLogout();
    }
  };

  const AutoScrollAndExpand = () => {
    const expandDiv = (divId: string) => {
      let div = document.getElementById(divId);
      if (div) {
        if (div.getAttribute('aria-expanded') === 'false') {
          div.click();
        }
      }
    };
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        if (hash === 'AddHighSchool') {
          setTimeout(() => {
            scrollToObject(hash, 200);
          }, 1500);
        } else if (hash === 'is_reported_all_grade_12') {
          setTimeout(() => {
            scrollToObject(hash, 100);
          }, 1500);
        } else if (hash === 'course_scheduling_system_is_using') {
          setTimeout(() => {
            scrollToObject(hash, 100);
          }, 1500);
        } else if (hash.includes('schoolName_')) {
          let str = hash.replaceAll('schoolName_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('schoolYear_')) {
          let str = hash.replaceAll('schoolYear_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('schedule_')) {
          let str = hash.replaceAll('schedule_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('courseName_')) {
          let str = hash.replaceAll('courseName_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('typeOfClass_')) {
          let str = hash.replaceAll('typeOfClass_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('collegeTookClass_')) {
          let str = hash.replaceAll('collegeTookClass_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('CNGradingScale_')) {
          let str = hash.replaceAll('CNGradingScale_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('lowestGrade_')) {
          let str = hash.replaceAll('lowestGrade_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('highestGrade_')) {
          let str = hash.replaceAll('highestGrade_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('otherGradeScale_')) {
          let str = hash.replaceAll('otherGradeScale_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('takeSemester_')) {
          let str = hash.replaceAll('takeSemester_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('scheduleTranscript_')) {
          let str = hash.replaceAll('scheduleTranscript_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('finalGrade_')) {
          let str = hash.replaceAll('finalGrade_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('finalCredits_')) {
          let str = hash.replaceAll('finalCredits_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('grade_')) {
          let str = hash.replaceAll('grade_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('credits_')) {
          let str = hash.replaceAll('credits_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        } else if (hash.includes('finalCredits_')) {
          let str = hash.replaceAll('finalCredits_', '');
          let ar = str.split('_');
          let itemIndex = Number(ar[0]);
          setTimeout(() => {
            expandDiv(`schoolItem${itemIndex}`);
            try {
              let sid = Number(ar[1]);
              setTimeout(() => {
                expandDiv(`subjectItem${sid}`);
                setTimeout(() => {
                  scrollToObject(hash, 100);
                }, 1500);
              }, 2000);
            } catch (ex2) {
              //skip
            }
          }, 2000);
        }
        // CourseWorks checking:
        else if (hash.includes('courseworkSchedulingSystem_')) {
          let str = hash.replaceAll('courseworkSchedulingSystem_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`courseWorkItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('courseworkTitle_')) {
          let str = hash.replaceAll('courseworkTitle_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`courseWorkItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('courseworkLevel_')) {
          let str = hash.replaceAll('courseworkLevel_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`courseWorkItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('courseworkSchedule_')) {
          let str = hash.replaceAll('courseworkSchedule_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`courseWorkItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('courseworkSubject_')) {
          let str = hash.replaceAll('courseworkSubject_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`courseWorkItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        }
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      try {
      setLoading(true);
      dispatch(getHighSchoolData(studentId));
      const res = await dispatch(getGradeAndCourse(studentId));
      const dataLoaded = res.payload;
      if (res.meta?.requestStatus === 'fulfilled' && dataLoaded) {
        const course_title = checkEnableParseJSON(dataLoaded.course_title, {});
        formik.resetForm({values: {
          ...dataLoaded,
          is_reported_all_grade_12: dataLoaded.is_reported_all_grade_12 ?? false,
          course_title,
          have12thGradeCourses: course_title.have12thGradeCourses ?? false,
        }})

        let gradeCourses: any[] = tryParseJSON(dataLoaded.grade_12_course_array) || [];
        resetIndexGradecourse(gradeCourses);
        setCourseData(gradeCourses);
        setCourseWorkData(tryParseJSON(dataLoaded.course_array) || []);

        await checkInputSchool(gradeCourses, gradeLevel);
        setTimeout(() => {
          AutoScrollAndExpand();
        }, 2000);
        const pageStatus: {
          student_completed: boolean;
        } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.GRADE_12);
        if(pageStatus) {
          setReviewedAndComplete(pageStatus.student_completed);
        }
      }
      } finally {
      setLoading(false);
      formik.setStatus('idle');
      }
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
    localStorage.setItem('lastGradePage', '12');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const hash = location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      AutoScrollAndExpand();
    }
  }, [location]);

  const handleAddCourse = () => {
    if (courseData.length > MAX_COURSES - 1) return;
    setCourseData([...courseData, {}]);
  };
  const handleSetCurrentCourse = (e: boolean) => {
    if (e) {
      genMyCourse12();
    }
    // else {
    //   setOpenConfirmGenCoures(true);
    // }
  };

    const removeAllCourse12 = () => {
      const arr: any[] = [];
      formik.setFieldValue('number_of_course_to_report', arr.length);
      setTimeout(() => setCourseWorkData([...arr]), 100);
      formik.setFieldValue('is_fields_enter_your_current_year_course', false);
    }

    const genMyCourse12 = () => {
        const newCourseWorkData: any[] = [];
        courseData.forEach((item) => {
            if (item.subjectDetails?.length) {
                item.subjectDetails.forEach((sub: any) => {
                  let schedule:any = [];
                  let scheduleKey  = item.schedule;
                    switch(item.schedule) {
                      case "Semester":
                        schedule = [
                          sub.isFirstSemester ? `First ${scheduleKey}` : null,
                          sub.isSecondSemester ? `Second ${scheduleKey}` : null,
                        ].filter((i) => !!i);
                        break;
                      case 'Trimester':
                        schedule = [
                          sub.isFirstSemester ? `First ${scheduleKey}` : null,
                          sub.isSecondSemester ? `Second ${scheduleKey}` : null,
                        ].filter((i) => !!i);
                        break;
                      case 'Quarters':
                      case 'Quarter': 
                        scheduleKey = 'Quarter';
                        schedule = [
                            sub.isFirstSemester ? `First ${scheduleKey}` : null,
                            sub.isSecondSemester ? `Second ${scheduleKey}` : null,
                            sub.isThirdSemester ? `Third ${scheduleKey}` : null,
                            sub.isFourthSemester ? `Fourth ${scheduleKey}` : null,
                        ].filter((i) => !!i);
                        break;
                      case 'Yearly':
                        schedule = ['Full Year'];
                    }
                    newCourseWorkData.push({
                        course_scheduling_system_is_using: scheduleKey,
                        title: sub.courseName,
                        // Must match CourseWork levelOptions / SubjectConfig "Type of Class"
                        level: sub.typeOfClass || sub.type_of_class || 'Regular/Standard',
                        schedule,
                        subject: sub.subject,
                    });
                });
            }
        });

        formik.setFieldValue('number_of_course_to_report', newCourseWorkData.length);
        setTimeout(() => setCourseWorkData([...newCourseWorkData]), 100);
    };

  const handleExpandAll = () => {
    if (!check) {
      setExpandAll(!expandAll);
      if (!expandAll) {
        setExpandActive(courseData.length);
      } else {
        setExpandActive(0);
      }
    } else {
      setExpandAll(!expandAll);
    }
  };

  const handleExpandActive = (value: any) => {
    if (!check) {
      value
        ? setExpandActive(Math.abs(expandActive - 1))
        : setExpandActive(Math.abs(expandActive + 1));
    }
  };

  // React.useEffect(() => {
  //   if (expandActive === courseData.length) {
  //     setExpandAll(true);
  //   }

  //   if (expandActive === 0) {
  //     setExpandAll(false);
  //   }
  // }, [expandActive, courseData.length]);

  const handleExpandAllCourseWork = () => {
    setExpandAllCourseWork(!expandAllCourseWork);
    if (!expandAllCourseWork) {
      setExpandActiveCourseWork(courseWorkData.length);
    } else {
      setExpandActiveCourseWork(0);
    }
  };

  const handleExpandActiveCourseWork = (value: any) => {
    value
      ? setExpandActiveCourseWork(Math.abs(expandActiveCourseWork - 1))
      : setExpandActiveCourseWork(Math.abs(expandActiveCourseWork + 1));
  };

  React.useEffect(() => {
    if (expandActiveCourseWork === courseWorkData.length) {
      setExpandAllCourseWork(true);
    }

    if (expandActiveCourseWork === 0) {
      setExpandAllCourseWork(false);
    }
  }, [expandActiveCourseWork, courseWorkData.length]);

  // BEGIN - Auto save function ==========
  React.useEffect(() => {
    if (!!formik.status) debounceSaving();
  }, [formik.values, courseData, courseWorkData]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // END -  Auto save function ==========

  const [forceRenderKey, setForceRenderKey] = React.useState(0);
  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    const dataList = reorder(courseData, result.source.index, result.destination.index);
    setCourseData([...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };
  const onDragEndForCourseWork = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    const dataList = reorder(courseWorkData, result.source.index, result.destination.index);
    setCourseWorkData([...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };

  const handleAddSubject = () => {
    if (courseWorkData.length > MAX_SUBJECTS - 1) return;
    setCourseWorkData([...courseWorkData, {}]);
  };

  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [removeIndex, setRemoveIndex] = React.useState<number | null>(null);
  const [openConfirmCourseWork, setOpenConfirmCourseWork] = React.useState(false);
  const [removeIndexCourseWork, setRemoveIndexCourseWork] = React.useState<number | null>(null);
  const [openConfirmGenCoures, setOpenConfirmGenCoures] = React.useState(false);
  const [showCheckModal, setShowCheckModal] = React.useState(false);

  const handleClose = () => {
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleConfirm = (index: number) => {
    const newCourseData = [...courseData];
    newCourseData.splice(index, 1);
    setCourseData(newCourseData);
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleRemoveCourse = (index: number) => {
    setRemoveIndex(index);
    setOpenConfirm(true);
  };
  const handleCloseCourseWork = () => {
    setOpenConfirmCourseWork(false);
    setRemoveIndexCourseWork(null);
  };
  const handleConfirmCourseWork = (index: number) => {
    const newCourseWorkData = [...courseWorkData];
    newCourseWorkData.splice(index, 1);
    setCourseWorkData(newCourseWorkData);
    setOpenConfirmCourseWork(false);
    setRemoveIndexCourseWork(null);
  };
  const handleRemoveCourseWork = (index: number) => {
    setRemoveIndexCourseWork(index);
    setOpenConfirmCourseWork(true);
  };

  const handleCloseGenCourse = () => {
    setOpenConfirmGenCoures(false);
    formik.setFieldValue('is_fields_enter_your_current_year_course', true);
  };

  const handleCheckFields = () => {
    setShowCheckModal(true);
  };

  const handleCloseCheckModal = () => {
    setShowCheckModal(false);
  };

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.GRADE_12, reviewedAndComplete, setReviewedAndComplete);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <>
       <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'High School Courses' },
          { percentOnProcess: 60, title: 'Course Confirmation' },
        ]}
        title="12th Grade"
        process={1}
        icon={<StackedLineChartIcon />}
        isMobile={isMobile}
      />


      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                12th Grade
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <div className="fs-6 text-dark my-2 fw-bold">
                        <InfoOutlinedIcon fontSize="small" className="mx-1" />
                        Courses & Grades
                      </div>
                      <div className="d-flex flex-wrap text-field-light">
                        Many college applications will want you to list your Courses and Grades and/or
                        GPA in various formats. Enter your information as you complete each of your high
                        school courses to make it easy for you during college application season.
                      </div>
                    </React.Fragment>
                  }
                  placement="right-start"
                >
                  <div className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'} p-1`}>Courses & Grades</div>
                </HtmlTooltip>
              </Grid>

              {showWarning && (
                <Grid xs={12}>
                  <div className="alert alert-danger" role="alert">
                    {errorArr && errorArr.length > 0 && (
                      <>
                        Prior to entering your coursework by grade year, go to Education &gt;
                        <a
                          href={'/#/application/high-school/#' + errorArr[0].value}
                          title="click to return the high school page"
                        >
                          {' '}
                          High School{' '}
                        </a>
                        &nbsp; and enter the following information for each of the high
                        school(s) you attended.
                        {` ${errorArr[0].name}`}
                      </>
                    )}
                  </div>
                </Grid>
              )}

              <Grid xs={12}>
                <div className="bg-light rounded p-2" style={{ fontSize: '1rem' }}>
                  <div>App Notes:</div>
                  <div>{`Common App: Allows entry of high school, schedule type, course name, grade(s), and high school credits.`}</div>
                  <div>{`UC App: Only permits input of A-G courses and grade(s). Non-A-G courses (e.g., PE/Health) will be considered.`}</div>
                  <div>{`CSU App: Only permits input of A-G courses and grade(s). Non-A-G courses (e.g., PE/Health) will be considered.`}</div>
                  <div className="pt-2">{`If your school uses multiple term types for grades, please select a second "grading system" under Education > High School.`}
                  <br/>Then, list your high school twice for courses taken during the second term type, including the relevant coursework.</div>
                </div>
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  logo="span-cm-logo"
                  name="course_title.have12thGradeCourses"
                  values={formik.values.course_title.have12thGradeCourses}
                  onClear={() => formik.setFieldValue('course_title.have12thGradeCourses', '')}
                  onChange={formik.handleChange}
                  label="Do you have 12th grade courses on your transcript with official grades? (If your 12th grade courses are still in progress, report them in the Current or Most Recent Year Courses section of your Common App)*"
                  isMissing={!formik.values.course_title.have12thGradeCourses && check ? true : false}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              {courseData.length > 0 && (
                <Grid xs={12}>
                  <div className="d-flex justify-content-end">
                    <ExpandMore
                      aria-expanded={expandAll}
                      aria-label="show all"
                      onClick={handleExpandAll}
                    >
                      {!expandAll ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                    </ExpandMore>
                  </div>
                </Grid>
              )}

              <Grid xs={12}>
                <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                  <Droppable droppableId="list">
                    {(provided) => (
                      <div className='w-100 bg-white py-2 rounded-3' ref={provided.innerRef} {...provided.droppableProps} style={{
                        paddingRight: isMobile ? "10px" : "30px",
                        paddingLeft: "10px"
                      }}>
                        {(courseData || []).map((item, index) => (
                          <div key={index + '-' + courseData.length}>
                            <Draggable draggableId={index + '-' + courseData.length} index={index} isDragDisabled={isMobile}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...(isMobile ? {} : provided.dragHandleProps)}
                                >
                                  <div
                                    key={index + '-' + courseData.length}
                                    className="position-relative"
                                  >
                                    <CourseConfig
                                      dataUpPrefix="g12"
                                      expandAll={expandedArr[index]}
                                      onExpandChange={(idx, expanded) => {
                                        setExpandedArr((prev) => {
                                          const { next, master } = applyCardExpand(prev, idx, expanded);
                                          if (master !== undefined) setExpandAll(master);
                                          return next;
                                        });
                                      }}
                                      handleExpandActive={handleExpandActive}
                                      is12
                                      defaultGradeValue="11th Grade"
                                      handleSave={(values) => {
                                        setCourseData((prev) => {
                                          const newCourseData = [...prev];
                                          const existing = newCourseData[index] ?? {};
                                          newCourseData.splice(index, 1, {
                                            ...existing,
                                            ...values,
                                          });
                                          return newCourseData;
                                        });
                                      }}
                                      item={item}
                                      index={index + 1}
                                      total={courseData.length}
                                      isMobile={isMobile}
                                      disabled={reviewedAndComplete}
                                    />
                                    <RemoveCircleOutlineIcon
                                      className="position-absolute text-field-light pointer"
                                      style={{ 
                                        right: isMobile ? '-20px' : '-24px', 
                                        top: '16px',
                                        fontSize: isMobile ? '18px' : '24px'
                                      }}
                                      onClick={() => {
                                        if (reviewedAndComplete) return;
                                        handleRemoveCourse(index);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>

              <Grid xs={12}>
                <div className="my-3 w-100 d-flex flex-column align-items-center">
                  <div className="text-field-light sized70">{`You can add up to ${MAX_COURSES} courses`}</div>
                  <Button variant="primary" className="p-2 px-5" onClick={handleAddCourse} disabled={reviewedAndComplete}>
                    Add Additional High Schools
                  </Button>
                </div>
              </Grid>

              <Grid xs={12}>
                <div id="is_reported_all_grade_12" className="common-flag pt-3">
                  <div className="label-14px mb-3">
                    Please indicate that you have reported all courses and grades for 12th grade.*
                  </div>
                  <CheckboxInput
                    name="is_reported_all_grade_12"
                    values={formik.values.is_reported_all_grade_12}
                    onChange={(e) => {
                      formik.setFieldValue('is_reported_all_grade_12', e.target.checked);
                    }}
                    label="I have reported all of my courses for this grade."
                    isMissing={!formik.values.is_reported_all_grade_12 && check ? true : false}
                    disabled={reviewedAndComplete}
                  />
                  <div className="label-14px my-3">
                    Have you indicated all your middle school, post-12th grade, or summer courses?
                  </div>
                  <CheckboxInput
                    name="course_title.is_indicated_all_course"
                    values={formik.values.course_title?.is_indicated_all_course}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'course_title.is_indicated_all_course',
                        e.target.checked
                      );
                    }}
                    label="I indicated all my middle school, post-12th grade, or summer courses."
                    disabled={reviewedAndComplete}
                  />
                </div>
              </Grid>
            </Grid>

            <div className={`text-dark ${isMobile ? 'fs-6' : 'fs-5'} p-1 fw-bold ${isMobile ? 'my-2' : 'my-3'}`}>
              Current or Most Recent Year Courses
            </div>

            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className={`text-dark ${isMobile ? 'fs-6' : 'fs-5'} p-1 fw-bold`}>Coursework</div>
              </Grid>

              <Grid xs={12}>
                <GroupRadioButton
                  id={'course_scheduling_system_is_using'}
                  logo="span-cm-logo"
                  label="Please select the main course scheduling system your institution is using.*"
                  options={['Semester', 'Trimester', 'Quarter', 'Yearly']}
                  mdCol={isMobile ? 2 : 3}
                  values={formik.values.course_scheduling_system_is_using}
                  onChange={formik.handleChange}
                  name="course_scheduling_system_is_using"
                  isMissing={!formik.values.course_scheduling_system_is_using && check ? true : false}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              <Grid xs={12}>
                <CheckboxInput
                  label="My 12th grade courses are my current courses"
                  name="is_fields_enter_your_current_year_course"
                  values={formik.values.is_fields_enter_your_current_year_course}
                  onChange={(e) => {
                    formik.handleChange(e);
                    handleSetCurrentCourse(e.target.checked);
                  }}
                  disabled={reviewedAndComplete}
                />
                {formik.values.is_fields_enter_your_current_year_course && (
                <div className="label-14px text-field-light pt-2">
                Checking this box will pre-fill your 12th-grade coursework below.<br/>
                If your 12th-grade courses have more than one scheduling system (E.g., semester grades and yearly grades), please review and adjust each course schedule manually for accuracy.
                </div>
                )}

              </Grid>
            {formik.values.is_fields_enter_your_current_year_course && (
              <>                
              <Grid xs={12}>
                <div className="text-field-light my-2">
                  Please list all courses you are taking this academic year. If you are not currently
                  enrolled, please list courses from your most recent academic year.
                </div>
              </Grid>

              {courseWorkData.length > 0 && (
                <Grid xs={12}>
                  <div className="d-flex justify-content-end">
                    <ExpandMore
                      aria-expanded={expandAllCourseWork}
                      aria-label="show all"
                      onClick={handleExpandAllCourseWork}
                    >
                      {!expandAllCourseWork ? (
                        <KeyboardDoubleArrowDownIcon />
                      ) : (
                        <KeyboardDoubleArrowUpIcon />
                      )}
                    </ExpandMore>
                  </div>
                </Grid>
              )}
            
              <Grid xs={12}>
                <DragDropContext onDragEnd={onDragEndForCourseWork} key={forceRenderKey}>
                  <Droppable droppableId="list">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {(courseWorkData || []).map((item, index) => (
                          <div key={index + '-' + courseWorkData.length}>
                            <Draggable
                              draggableId={index + '-' + courseWorkData.length}
                              index={index}
                              isDragDisabled={isMobile}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...(isMobile ? {} : provided.dragHandleProps)}
                                >
                                  <div
                                    key={index + '-' + courseWorkData.length}
                                    className="position-relative"
                                  >
                                    <CourseWork
                                      formik={formik}
                                      expandAll={expandAllCourseWork}
                                      handleExpandActive={handleExpandActiveCourseWork}
                                      handleSave={(values) => {
                                        setCourseWorkData((prev) => {
                                          const newCourseWorkData = [...prev];
                                          const existing = newCourseWorkData[index] ?? {};
                                          newCourseWorkData.splice(index, 1, {
                                            ...existing,
                                            ...values,
                                          });
                                          return newCourseWorkData;
                                        });
                                      }}
                                      item={item}
                                      index={index + 1}
                                      total={courseWorkData.length}
                                      isMobile={isMobile}
                                    />
                                    <RemoveCircleOutlineIcon
                                      className="position-absolute text-field-light pointer"
                                      style={{ 
                                        right: isMobile ? '-20px' : '-24px', 
                                        top: '16px',
                                        fontSize: isMobile ? '18px' : '24px'
                                      }}
                                      onClick={() => {
                                        if (reviewedAndComplete) return;
                                        handleRemoveCourseWork(index);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>

              <Grid xs={12}>
                <div className="my-3 w-100 d-flex flex-column align-items-center">
                  <div className="text-field-light sized70">{`You can add up to ${MAX_SUBJECTS} subjects`}</div>
                  <Button variant="primary" className="p-2 px-5" onClick={handleAddSubject} disabled={reviewedAndComplete}>
                    Add Subject
                  </Button>
                </div>
              </Grid>
              
              </>
            )}

            </Grid>

            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {course.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`} 
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
      <ModalConfirm 
        open={openConfirm}
        handleClose={handleClose} 
        handleConfirm={() => {
          if (removeIndex !== null) handleConfirm(removeIndex);
        }}
        title=""
        message="Are you sure you want to remove this high school?"
        confirmText="Remove"
        cancelText="Cancel"
      />
      <ModalConfirm 
        open={openConfirmCourseWork}
        handleClose={handleCloseCourseWork} 
        handleConfirm={() => {
          if (removeIndexCourseWork !== null) handleConfirmCourseWork(removeIndexCourseWork);
        }}
        title=""
        message="Are you sure you want to delete this course?"
        confirmText="Remove"
        cancelText="Cancel"
      />
      <ModalConfirm 
        open={openConfirmGenCoures}
        handleClose={handleCloseGenCourse} 
        handleConfirm={() => {
          setOpenConfirmGenCoures(false);
          removeAllCourse12();
        }}
        title=""
        useHtmlMessage={true}
        message={`<div class="text-left">Are you sure your 12th grades courses are not your current courses?<br/>
            If you uncheck, any manually added courses below will be deleted.</div>`}
        confirmText="Remove"
        cancelText="Cancel"
      />

      <ModalCheckGradeField
        show={showCheckModal}
        onClose={handleCloseCheckModal}
        data={courseData}
        page="12th-grade"
        myGradeAndCourse={formik.values}
      />
    </>
  );
};

export default TwelvethGrade;
